<template>
    <div class="main">
        <c-panel title="SOLICITAÇÕES DE MATRÍCULA" titleIcon="fas fa-user-plus">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="5">
                    <el-select v-model="filtro.tipo_solicitacao_matricula_id" placeholder="Tipo" filterable clearable @change="load" style="width:100%;">
                        <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="4">
                    <el-select v-model="filtro.status" placeholder="Situação" clearable @change="load" style="width:100%;">
                        <el-option v-for="s in STATUS" :key="s.v" :label="s.l" :value="s.v"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="4">
                    <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Data início" style="width:100%;"></el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="4">
                    <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Data fim" style="width:100%;"></el-date-picker>
                </el-col>
                <el-col :xs="24" :sm="7" class="u-text-right">
                    <el-button @click="load" icon="el-icon-search">FILTRAR</el-button>
                    <el-button class="u-ml-10" @click="imprimirRelacao" icon="el-icon-printer" plain>RELAÇÃO</el-button>
                    <router-link class="u-ml-10" to="/admin/solicitacao-matricula/cadastro"><el-button type="primary" icon="el-icon-plus">NOVA</el-button></router-link>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:110px;">Data</th>
                        <th>Solicitante</th>
                        <th style="width:170px;">Tipo</th>
                        <th style="width:160px;">Curso/série</th>
                        <th style="width:120px;">Situação</th>
                        <th style="width:120px;" class="u-text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="s in items" :key="s.id">
                        <td>{{ s.data_solicitacao | formatarData }}</td>
                        <td>
                            <span v-if="s.aluno">{{ s.aluno.nome }} <small style="color:#909399;">(aluno)</small></span>
                            <span v-else>{{ s.solicitante_nome || '—' }} <small style="color:#909399;">(candidato)</small></span>
                        </td>
                        <td>{{ s.tipo ? s.tipo.nome : '—' }}</td>
                        <td>{{ s.curso ? s.curso.nome : '—' }}</td>
                        <td><el-tag :type="tagStatus(s.status)" size="mini">{{ rotuloStatus(s.status) }}</el-tag></td>
                        <td class="u-text-center">
                            <router-link :to="'/admin/solicitacao-matricula/edit/' + s.id">
                                <el-button size="mini" type="info" icon="el-icon-edit" plain></el-button>
                            </router-link>
                            <el-button class="u-ml-10" size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(s.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="6" class="u-text-center" style="padding: 20px; color: #909399;">Nenhuma solicitação.</td>
                    </tr>
                </tbody>
            </table>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
const STATUS = [
    { v: 1, l: 'Aberta' }, { v: 2, l: 'Em análise' },
    { v: 3, l: 'Deferida' }, { v: 4, l: 'Indeferida' }, { v: 5, l: 'Cancelada' }
]
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data () {
        return {
            STATUS, items: [], tipos: [],
            filtro: { tipo_solicitacao_matricula_id: null, status: null, data_inicio: null, data_fim: null }
        }
    },
    mounted () { this.load(); this.carregarTipos() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instId () { return this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null },
        rotuloStatus (s) { const x = STATUS.find(o => o.v === Number(s)); return x ? x.l : '?' },
        tagStatus (s) { return { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger', 5: '' }[s] || '' },

        load () {
            this.$axios.post(`${this.baseUrl()}/api/solicitacao-matricula/getAllPaginate`,
                { instituicao_id: this.instId(), ...this.filtro },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
              .catch(e => this.$store.commit('throwException', e))
        },
        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-solicitacao-matricula/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
        },
        excluir (id) {
            this.$confirm('Excluir solicitação?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/solicitacao-matricula/delete/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    this.load()
                })
            }).catch(() => {})
        },
        imprimirRelacao () {
            this.$axios.post(`${this.baseUrl()}/api/solicitacao-matricula/imprimirRelacao`,
                { instituicao_id: this.instId(), ...this.filtro },
                { ...this.$store.getters.getHeaderAuth, responseType: 'blob' }
            ).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
                window.open(url, '_blank')
            }).catch(e => this.$store.commit('throwException', e))
        }
    }
}
</script>
